export interface Image {
  name: string;
  url: string;
  s3Url: string;
  size: number; // Size in bytes
  type?: string; // MIME type
  uploadedAt?: string; // ISO date string
  lastModified: Date; // ISO date string
  isMain?: boolean;
  uso_imagen?: UsoImagenType;
  Metadata?: {
    uso_imagen?: UsoImagenType;
  }; // Additional metadata
}

export type UsoImagenType =
  | "GENERAL"
  | "PRINCIPAL"
  | "FRONTAL"
  | "LATERAL"
  | "POSTERIOR"
  | "SUPERIOR"
  | "ANGULO"
  | "DETALLE"
  | "THUMBNAIL"
  | "ICONO"
  | "CATALOGO"
  | "BANNER"
  | "PAQUETE"
  | "TABLA_TALLAS"
  | "ESQUEMA"
  | "INSTALACION"
  | "COMPARATIVA"
  | "PROMOCIONAL"
  | "ETIQUETA"
  | "INSTRUCCIONES"
  | "GARANTIA"
  | "ESPECIFICACIONES"
  | "VIDEO"
  | "360"
  | "ZOOM";

// Constantes para uso fácil en el código
export const USO_IMAGEN = {
  GENERAL: "GENERAL" as UsoImagenType,
  PRINCIPAL: "PRINCIPAL" as UsoImagenType,
  FRONTAL: "FRONTAL" as UsoImagenType,
  LATERAL: "LATERAL" as UsoImagenType,
  POSTERIOR: "POSTERIOR" as UsoImagenType,
  SUPERIOR: "SUPERIOR" as UsoImagenType,
  ANGULO: "ANGULO" as UsoImagenType,
  DETALLE: "DETALLE" as UsoImagenType,
  THUMBNAIL: "THUMBNAIL" as UsoImagenType,
  ICONO: "ICONO" as UsoImagenType,
  CATALOGO: "CATALOGO" as UsoImagenType,
  BANNER: "BANNER" as UsoImagenType,
  PAQUETE: "PAQUETE" as UsoImagenType,
  TABLA_TALLAS: "TABLA_TALLAS" as UsoImagenType,
  ESQUEMA: "ESQUEMA" as UsoImagenType,
  INSTALACION: "INSTALACION" as UsoImagenType,
  COMPARATIVA: "COMPARATIVA" as UsoImagenType,
  PROMOCIONAL: "PROMOCIONAL" as UsoImagenType,
  ETIQUETA: "ETIQUETA" as UsoImagenType,
  INSTRUCCIONES: "INSTRUCCIONES" as UsoImagenType,
  GARANTIA: "GARANTIA" as UsoImagenType,
  ESPECIFICACIONES: "ESPECIFICACIONES" as UsoImagenType,
  VIDEO: "VIDEO" as UsoImagenType,
  VISTA_360: "360" as UsoImagenType,
  ZOOM: "ZOOM" as UsoImagenType,
};

// Función de utilidad para validar el tipo
export const isValidUsoImagen = (value: string): value is UsoImagenType => {
  const validValues: string[] = [
    "GENERAL",
    "PRINCIPAL",
    "FRONTAL",
    "LATERAL",
    "POSTERIOR",
    "SUPERIOR",
    "ANGULO",
    "DETALLE",
    "THUMBNAIL",
    "ICONO",
    "CATALOGO",
    "BANNER",
    "PAQUETE",
    "TABLA_TALLAS",
    "ESQUEMA",
    "INSTALACION",
    "COMPARATIVA",
    "PROMOCIONAL",
    "ETIQUETA",
    "INSTRUCCIONES",
    "GARANTIA",
    "ESPECIFICACIONES",
    "VIDEO",
    "360",
    "ZOOM",
  ];
  return validValues.includes(value);
};

// Mapeo de tipos a labels para mostrar en UI
export const USO_IMAGEN_LABELS: Record<UsoImagenType, string> = {
  GENERAL: "Uso General",
  PRINCIPAL: "Imagen Principal",
  FRONTAL: "Vista Frontal",
  LATERAL: "Vista Lateral",
  POSTERIOR: "Vista Posterior",
  SUPERIOR: "Vista Superior",
  ANGULO: "Vista en Ángulo",
  DETALLE: "Detalle",
  THUMBNAIL: "Miniatura",
  ICONO: "Icono",
  CATALOGO: "Catálogo",
  BANNER: "Banner",
  PAQUETE: "Embalaje",
  TABLA_TALLAS: "Tabla de Tallas",
  ESQUEMA: "Esquema",
  INSTALACION: "Instalación",
  COMPARATIVA: "Comparativa",
  PROMOCIONAL: "Promocional",
  ETIQUETA: "Etiqueta",
  INSTRUCCIONES: "Instrucciones",
  GARANTIA: "Garantía",
  ESPECIFICACIONES: "Especificaciones",
  VIDEO: "Video",
  "360": "Vista 360°",
  ZOOM: "Zoom",
};


// Función para obtener el usoImagen de una imagen (compatible con ambas estructuras)
export const getUsoImagen = (image: Image): UsoImagenType => {
  //console.info('buscando en updateUsoImagen',image);
  return image.uso_imagen || image.Metadata?.uso_imagen || 'GENERAL';
};

// Función para actualizar el usoImagen en una imagen
export const updateUsoImagen = (image: Image, nuevoUso: UsoImagenType): Image => {
  return {
    ...image,
    uso_imagen: nuevoUso,
    Metadata: {
      ...image.Metadata,
      //usoimagen: nuevoUso
    }
  };
};